// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.9c07980f0',
  revision: '9c07980f0',
  branch: 'develop',
  date: 'Fri, 11 Sep 2026 14:12:55 GMT'
};